import React, { useEffect } from "react";
import { observer, useLocalStore } from "mobx-react";
import useDocumentTitle from "../layout/title";
import { Box, Button, Grid, Skeleton } from "@mui/material";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";
import View from "./View";
import QTable from "./QTable";

const Overview = () => {
  useDocumentTitle("Dashboard Quotes");
  const { instance, accounts } = useMsal();
  const lstore = useLocalStore(() => ({
    loading: true,
    arr: null,
    quote: null,
  }));
  const fetch = () => {
    console.log("window.location.pathname");
    console.log(window.location.pathname);
    lstore.loading = true;
    apiCall(
      window.location.pathname.replace(/^\//, ""),
      { method: "GET" },
      (json) => {
        if (window.location.pathname.length > 7)
          lstore.quote = { ...json, Data: JSON.parse(json.data) };
        else lstore.arr = json;
        lstore.loading = false;
      },
      instance,
      accounts
    );
  };
  useEffect(() => {
    fetch();
  }, []);
  return (
    <Box m={1} p={1} style={{ background: "white" }}>
      {lstore.loading &&
        ["", "", "", "", ""].map((e, i) => (
          <Box m={1} key={i}>
            <Skeleton variant="rect" width={"auto"} height={40} />
          </Box>
        ))}
      {!lstore.loading && !lstore.quote && lstore.arr && (
        <Grid item xs={12}>
          <QTable store={lstore} />
        </Grid>
      )}
      {lstore.quote && (
        <>
          <View data={lstore.quote} />
          <Button
            onClick={(e) => {
              if (lstore.arr === null) window.location.assign("/Quote");
              lstore.quote = null;
            }}
          >
            back
          </Button>
        </>
      )}
    </Box>
  );
};

export default observer(Overview);
